import React, { useEffect, useState, useContext } from 'react';
import { getFormattedPrice } from '../.././components/helper/common'
import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Sucess from '../../../assets/success.svg';
import Arrow from '../../../assets/arrow.svg';
import styles from './OrderConfirmView.module.scss';
import Toast from '../../components/toast/Toast';
import AppContext, { IAppContext } from '../../Contexts/AppContext/AppContext';
import ViewTicketDetailPageContext, {
	IViewTicketDetailPageContext,
} from '../../Contexts/ViewTicketPageContext/ViewTicketPageContext';
import OrderConfirmPageContext, {
	IOrderConfirmContext,
} from '../../Contexts/OrderConfirmPageContext/OrderConfirmPageContext';
import LoaderIcon from '../../components/loaderIcon/LoaderIcon';
import MenuItemsPageContext, { IMenuItemContext } from '../../Contexts/MenuItemsPageContext/MenuItemsPageContext';
import PreAuthPageContext, { IPreAuthItemContext } from '../../Contexts/PreAuthPageContext/PreAuthPageContext';
import { useTranslation } from '../../hooks/useTranslation';


const OrderConfirmView: React.FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const {
		isValidSession,
		setIsValidSession,
		setValidSessionId,
		checkSessionData,
		validSessionId,
		toastMessage,
		updateToastMessage,
	} = useContext(AppContext) as IAppContext;
	const { getQRPayHost, payRedirectError } = useContext(OrderConfirmPageContext) as IOrderConfirmContext;
	const { ticketDetails, ticketError, setShouldRedirectToViewCheck, setTicketDetails } = useContext(
		ViewTicketDetailPageContext
	) as IViewTicketDetailPageContext;
	const { merchantData, updateMerchantDetail } = useContext(MenuItemsPageContext) as IMenuItemContext;
	const { setIsActiveSession } = useContext(PreAuthPageContext) as IPreAuthItemContext;
	const [totalPriceInCart, setTotalPriceInCart] = useState<number>(0);
	const [payView, setPayView] = useState<boolean>(false);
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const { storeId } = useParams<{ storeId: string }>();
	const isQrPayEnabled = localStorage.getItem('isQRPayEnabled') === 'true';
	const tableRefId = localStorage.getItem('tableRef');
	const merchantInfo = localStorage.getItem('merchantLogo');
	const isSessionAvailable = localStorage.getItem('storedSessionId');
	const shopName = localStorage.getItem('merchantName');
	const { getTicket } = useContext(ViewTicketDetailPageContext) as IViewTicketDetailPageContext;

	useEffect(() => {
		if (payRedirectError || ticketError) {
			const apiError = payRedirectError ? payRedirectError : ticketError;
			if (apiError && apiError.code === 'USER_SESSION_NOT_FOUND') {
				updateToastMessage(t('pages:home:error:sessionNotFound:message'));
			} else if (apiError && apiError.code === 'USER_SESSION_INVALID_TICKET') {
				updateToastMessage(t('pages:home:error:invalidTicket:message'));
			} else if (apiError && apiError.code === 'PARTIAL_PAYMENT_EXISTS') {
				updateToastMessage(t('pages:viewTicket:error:partialPayment:message'));
			} else {
				updateToastMessage(t('pages:viewTicket:error:ticketNotFound:message'));
			}
			setShowLoader(false);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [payRedirectError, ticketError]);

	const handleOrderView = () => {
		setShouldRedirectToViewCheck(false);
		setIsActiveSession(false);
		navigate(`/${storeId}?tableRef=${tableRefId}`);
	};
	const handlePayView = async () => {
		setShowLoader(true);
		setTicketDetails({});
		if (isSessionAvailable && storeId) {
			getTicket(storeId, isSessionAvailable, false);
			setPayView(true);
		}
	};

	const handleViewOpenTab = () => {
		navigate(`/${storeId}/viewOpenTab`);
	};

	useEffect(() => {
		if (payView && ticketDetails?.amountPaid) {
			if (Number(ticketDetails?.amountPaid > 0)) {
				updateToastMessage(t('pages:viewTicket:error:partialPayment:message'));
				return;
			}
			if (isValidSession && validSessionId && storeId) {
				getQRPayHost(storeId, validSessionId);
			}
			setPayView(false);
			setShowLoader(false);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ticketDetails, payView, isValidSession]);

	useEffect(() => {
		const smsCode = localStorage.getItem('clientCode') || '';
		if (!isSessionAvailable) {
			if (tableRefId && validSessionId && storeId) {
				checkSessionData(storeId, validSessionId, smsCode, tableRefId);
			}
		} else {
			setIsValidSession(true);
			setValidSessionId(isSessionAvailable);
			setShowLoader(true);
			if (storeId) {
				getTicket(storeId, isSessionAvailable, false);
			}
			setShowLoader(false);
		}
		if (storeId) {
			updateMerchantDetail(storeId);
		}
		localStorage.removeItem('orderDetail');
		updateToastMessage('');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	useEffect(() => {
		if (ticketDetails && ticketDetails.subtotal) {
			const parsedSubtotal = Number(ticketDetails.subtotal);
			if (parsedSubtotal >= 0) {
				setTotalPriceInCart(parsedSubtotal * 100);
			}
		}
	}, [ticketDetails]);


	return (
		<>
			<section id="orderConfirmContainer" className={`${styles.orderConfirmation} Container`}>
				<section className={`${styles.orderPage} `}>
					<div className={styles.logo}>
						{merchantInfo && (
							<img src={merchantInfo} className={`${styles.restaurantLogo}`} alt="restaurant name " />
						)}
					</div>

					<h3 className={styles.restaurantName}>{shopName}</h3>

					{!location.state?.orderPlaced && (
						<div className={styles.confirmationBlock}>
							<img src={Sucess} className={styles.successIcon} alt="successIcon"></img>
							<Typography variant="h4">{t('page:orderConfirm:tabStarted:heading')}</Typography>
							<Typography variant="body1" className={styles.bottompara}>
								{t('page:orderConfirm:selectMoreItems:text')}
							</Typography>
						</div>
					)}
					<div className={styles.orderActions}>
						<Button
							id="orderMoreBtn"
							type="button"
							color="primary"
							fullWidth
							className={`${styles.orderMoreBtn} ${styles.btn} fluid`}
							onClick={handleOrderView}
						>
							{t('page:orderConfirm:orderMore:button')}
						</Button>
						{isQrPayEnabled && (
							<Button
								type="button"
								id="payCheckButton"
								color="secondary"
								fullWidth
								className={`${styles.payBtn} ${styles.btn}`}
								onClick={handlePayView}
							>
								{showLoader && <LoaderIcon />}{t('page:orderConfirm:pay:button')}
							</Button>
						)}
						{toastMessage?.length > 0 && <Toast message={toastMessage} />}
					</div>
				</section>
				<div className={styles.viewdiv}>
					<Button onClick={handleViewOpenTab} className={styles.viewTab}>
						<div><Typography variant="body1" className={styles.viewTabhead}>{t('page:orderConfirm:viewOpenTab:text')}</Typography></div>
						<div className={styles.openTab}><Typography variant="body2" className={styles.pricetext}>{totalPriceInCart != undefined && totalPriceInCart >= 0 && merchantData?.currency
							? `  ${getFormattedPrice(totalPriceInCart, merchantData?.currency)}`
							: null}</Typography><img src={Arrow} className={""} alt="arrowIcon"></img></div>
					</Button>

					<Typography variant="body2" className={styles.order_last}>
						{t('page:orderConfirm:rescanQR:instruction')}
					</Typography>
				</div>

			</section>
		</>
	);
};

export default OrderConfirmView;
